import { createSlice } from '@reduxjs/toolkit';
import { isBannedRaisehand, isEnableBanAllRaisehand } from './functions';
import { getConferenceState } from '../base/conference/functions';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canRaisehand: undefined,
    actor: null,
    cascadeRaisedHandsQueue: []
};
export const approveParticipantRaisehand = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        return false;
    }
    const isBanned = isBannedRaisehand(participant, state);
    if (isBanned) {
        conference?.raisehandModerationApprove(id);
    }
};
export const rejectParticipantRaisehand = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        return false;
    }
    const isBanned = isBannedRaisehand(participant, state);
    const isModerator = isParticipantModerator(participant);
    if (!isBanned && !isModerator) {
        conference?.raisehandModerationReject(id);
    }
};
export const enableBanAllRaisehand = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllRaisehand(state);
    if (!isBanAll) {
        conference?.enableRaisehandModeration();
    }
};
export const disableBanAllRaisehand = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllRaisehand(state);
    if (isBanAll) {
        conference?.disableRaisehandModeration();
    }
};
const raisehandModeration = createSlice({
    name: 'features/raisehand-moderation',
    initialState,
    reducers: {
        disableRaisehandModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canRaisehand = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enableRaisehandModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canRaisehand = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: (state) => {
            state.canRaisehand = true;
        },
        localParticipantRejected: (state) => {
            state.canRaisehand = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: true
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: false
                };
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: false
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: true
                };
            }
        },
        updateCascadeRaisedHandsQueue: (state, action) => {
            const updatedParticipantIds = action.payload.map((el) => el.participantId);
            state.cascadeRaisedHandsQueue = [
                ...state.cascadeRaisedHandsQueue.filter((el) => !updatedParticipantIds.includes(el.participantId)),
                ...action.payload
            ];
        },
        emptyRaisedHandCascadeQueue: (state, action) => {
            const needEmptyIds = action.payload;
            state.cascadeRaisedHandsQueue = state.cascadeRaisedHandsQueue.filter(el => !needEmptyIds.includes(el.participantId));
        }
    }
});
ReducerRegistry.register('features/raisehand-moderation', raisehandModeration.reducer);
export const { disableRaisehandModeration, enableRaisehandModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected, updateCascadeRaisedHandsQueue, emptyRaisedHandCascadeQueue } = raisehandModeration.actions;
export default raisehandModeration.reducer;
